import type CSS from 'csstype';

import { extractCssStyle } from '../../utilities';

export interface BackgroundStylingProps {
  backgroundColor?: CSS.Property.BackgroundColor;
  background?: CSS.Property.Background;
}

export const BackgroundStyling = (props: BackgroundStylingProps) => extractCssStyle(props);
